(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPromoHero(hero) {
      if (hero.dataset.promoInit === 'true') return;
      var slides = hero.querySelectorAll('.promo-hero__slide');
      if (!slides.length) return;
      hero.dataset.promoInit = 'true';

      // position 0 = main background image (text yahin show hota hai), 1..n = extra images
      var total = slides.length + 1;
      var pos = 0;
      var timer = null;
      var speed = (parseInt(hero.dataset.speed, 10) || 5) * 1000;
      var dots = [];

      function show(p) {
        pos = p;
        slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === p - 1);
        });
        hero.classList.toggle('is-first', p === 0);
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === p);
        });
      }

      function go(p) {
        show((p + total) % total);
      }

      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        timer = setInterval(function () { go(pos + 1); }, speed);
      }

      // Arrows
      if (hero.dataset.arrows === 'true') {
        var prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'promo-hero__arrow promo-hero__arrow--prev';
        prev.setAttribute('aria-label', 'Previous image');
        prev.innerHTML = '&#10094;';
        prev.addEventListener('click', function () { go(pos - 1); });

        var next = document.createElement('button');
        next.type = 'button';
        next.className = 'promo-hero__arrow promo-hero__arrow--next';
        next.setAttribute('aria-label', 'Next image');
        next.innerHTML = '&#10095;';
        next.addEventListener('click', function () { go(pos + 1); });

        hero.appendChild(prev);
        hero.appendChild(next);
      }

      // Dots
      if (hero.dataset.dots === 'true') {
        var wrap = document.createElement('div');
        wrap.className = 'promo-hero__dots';
        for (var i = 0; i < total; i++) {
          (function (index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'promo-hero__dot';
            dot.setAttribute('aria-label', 'Go to image ' + (index + 1));
            dot.addEventListener('click', function () { go(index); });
            dots.push(dot);
            wrap.appendChild(dot);
          })(i);
        }
        hero.appendChild(wrap);
      }

      // Swipe (mobile)
      var startX = 0;
      hero.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        stop();
      }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) go(dx < 0 ? pos + 1 : pos - 1);
        start();
      }, { passive: true });

      // Desktop: hover par auto slide ruk jaye
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);

      show(0);
      start();
    }

    function initAll() {
      document.querySelectorAll('.promo-hero').forEach(initPromoHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
